import { useClientSettings } from "Hooks/useClientSettings";
import React from "react";
import { FaShieldAlt } from "react-icons/fa";
import { getApprovalPinnedFlightCopy } from "Utils/flightApproval";

function HasApproval({ approval }) {
	const { currency } = useClientSettings();

	if (approval) {
		const { amount } = approval;
		const copy = getApprovalPinnedFlightCopy(approval);
		return (
			<div className="my-3 rounded-lg border border-green-300 bg-green-50 px-3 py-2.5 shadow-sm ring-1 ring-green-200/70">
				<div className="flex items-start gap-2.5">
					<div className="mt-0.5 rounded-full bg-green-100 p-1.5 text-green-700">
						<FaShieldAlt className="text-sm" />
					</div>
					<div className="min-w-0 flex-1">
						<div className="flex flex-wrap items-center gap-x-2 gap-y-1">
							<div className="text-sm font-semibold text-green-800">{copy.title}</div>
							<div className="rounded-full border border-green-200 bg-green-100 px-2 py-0.5 text-[11px] font-semibold text-green-800">
								Limit: {currency} {amount}
							</div>
						</div>
						<div className="mt-0.5 text-xs leading-5 text-green-900/75">{copy.description}</div>
					</div>
				</div>
			</div>
		);
	}

	return null;
}

export default HasApproval;
